import React, {Suspense, lazy} from 'react';
import Nav from './components/Nav/nav'   
import Footer from './components/footer/Footer'   
import './App.css';  

import AnimatedCursor from "react-animated-cursor"  
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";

import AboutPage from './page/AboutPage/AboutPage';          
 
 
import Project from './page/project/Project'

import Certificate from './page/certificate/Certificate'     
import PAGE_NOT_FOUND from './components/404-page.js'

import Lottie from 'react-lottie';
import animationData from '././lotties/load1.json';


const Homepage=lazy(()=>import('./page/home/homepage'))


function App() {  
 
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };


    function Project1() {
      window.scrollTo(0, 0);
      return  <Project />  ;
    }
    function Certificate1() {
      window.scrollTo(0, 0);
      return  <Certificate />  ;
    }
    function AboutPage1() {
      window.scrollTo(0, 0);
      return  <AboutPage />  ;
    }
    function Homepage1() {
      window.scrollTo(0, 0);
      return  <Homepage/>  ;
    }


  return (
                        
<Suspense fallback={<div>
  <Lottie options={defaultOptions}
      style={{transform:"translate(0, -15%)", position:'absolute'}}
             height={"100%"}
             width={"100%"}           
                /> 
  <h3 className='lodingweb saving' style={{textAlign:'center'}}>Please wait while page is loading
  <span>.</span><span>.</span><span>.</span> 
  </h3>  
  
  </div>}>
  
<div style={{ backgroundImage: `url(${"them"})`, backgroundAttachment: 'fixed', backgroundSize:'cover'}} >
      
<AnimatedCursor
      innerSize={20}
      outerSize={35}
      color='46, 204, 113'
      outerAlpha={0.4}  
      innerScale={0.8}    
      outerScale={5}   
    />   
    

<Router>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
              <Nav/>
 <Switch>
          <Route exact  path="/">
             <Homepage1 />   
          </Route>

          <Route exact path="/.">

           <AboutPage1/>  

          </Route>

          <Route exact path="/..">                      
            <Certificate1 />
          </Route>      

          <Route exact path="/certificate">                      
            <Certificate1 />
          </Route>        

          <Route exact path="/   ">               
           <Project1 />          
          </Route>

          <Route exact path="/project">               
           <Project1 />          
          </Route>


          <Route exact path="/*">               
          <PAGE_NOT_FOUND/>
          </Route>
          </ Switch>
</Router>   


<Footer /> 
     
</div>      

</Suspense>  
);    
}       
  


export default App;
       

    
      